module.exports = __webpack_public_path__ + "img/flag-gb.b7bb8326.png";